<!-- Patient Details -->
<mat-card #patientCard class="patient-card">
  <div
    fxFlexFill
    *ngIf="patientLoading$ | async"
    fxLayout="row"
    fxLayoutAlign="center center"
  >
    <mat-spinner> </mat-spinner>
  </div>

  <div
    *ngIf="!(patientLoading$ | async)"
    fxLayout="column"
    fxLayoutAlign="start stretch"
  >
    <!-- Top Level Patient Information -->
    <portal-patient-top-level
      [text]="patientInfoText$ | async"
      [patient]="topLevelPatientData$ | async"
      [videoCallsEnabled]="videoCallsEnabled$ | async"
      (openNewMessage)="openNewMessage()"
      (openNewVideoCall)="openVideoCall()"
    >
    </portal-patient-top-level>
    <div fxLayout="row" fxLayoutAlign="start start">
      <!-- Sections List -->
      <portal-patient-sections-list
        [text]="patientInfoText$ | async"
        [sections]="sectionsToShow$ | async"
        [activeSection]="activeSection$ | async"
        (changeSection)="changeActiveSection($event)"
      >
      </portal-patient-sections-list>

      <!-- Section Detail -->
      <div class="section-detail" fxFlex="grow">
        <portal-patient-info
          *ngIf="(activeSection$ | async) !== 'forms'"
          [text]="patientInfoText$ | async"
          [isCore]="isCoreClinic$ | async"
          [activeSection]="activeSection$ | async"
          [patientInfo]="patientInfo$ | async"
          [partnerInfo]="partnerInfo$ | async"
          [contactInfo]="contactInfo$ | async"
          [labResults]="labResults$ | async"
          [manageContent]="'Coming Soon'"
        >
        </portal-patient-info>

        <!-- Forms MFE -->
        <ng-container *ngIf="(activeSection$ | async) === 'forms'">
          <ng-container *ngIf="formsLoaded$ | async; else formsLoading">
            <salve-clinic-patient-forms
              [attr.patient-id]="patientId$ | async"
              [attr.language]="selectedLanguage$ | async"
              [clinic_token]="xSalveClinicToken$ | async"
            ></salve-clinic-patient-forms>
          </ng-container>
          <ng-template #formsLoading>
            <div
              class="forms-loading"
              fxLayout="row"
              fxLayoutAlign="center center"
              role="status"
              aria-live="polite"
              aria-busy="true"
            >
              <mat-spinner></mat-spinner>
            </div>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </div>
</mat-card>

<!-- Calendar -->
<mat-card *ngIf="!(isCoreClinic$ | async)" class="calendar-card">
  <mat-toolbar fxLayoutAlign="start center" class="calendar-header">
    <h3 class="card-title">{{ calendarText.Calendar }}</h3>
  </mat-toolbar>
  <portal-patient-calendar
    [text]="calendarText"
    [events]="events$ | async"
    [videoCallsEnabled]="videoCallsEnabled$ | async"
    [viewDate]="viewDate"
  >
  </portal-patient-calendar>
</mat-card>
